import Phaser from 'phaser'
import { Alchemist, Barmaid, Bartender, Blacksmith, Fisherman, Kid1, Kid2, Merchant, Minter } from './NonPlayable'
import { sceneEvents } from '../events/EventsCenter'

const BOUNCE_VAL = 0

declare global
{
	namespace Phaser.GameObjects
	{
		interface GameObjectFactory
		{
			alchemist(x: number, y: number, texture: string, frame?: string | number): Alchemist;
			barmaid(x: number, y: number, texture: string, frame?: string | number): Barmaid;
			bartender(x: number, y: number, texture: string, frame?: string | number): Bartender;
			blacksmith(x: number, y: number, texture: string, frame?: string | number): Blacksmith;
			fisherman(x: number, y: number, texture: string, frame?: string | number): Fisherman;
			kid1(x: number, y: number, texture: string, frame?: string | number): Kid1;
			kid2(x: number, y: number, texture: string, frame?: string | number): Kid2;
			merchant(x: number, y: number, texture: string, frame?: string | number): Merchant;
			minter(x: number, y: number, texture: string, frame?: string | number): Minter;
			farmer(x: number, y: number, texture: string, frame?: string | number): Farmer
			coin(x: number, y: number, texture: string, frame?: string | number): Sprite
		}
	}
}

export class PlayerMovement {
	public up?: boolean
	public down?: boolean
	public left?: boolean
	public right?: boolean

	constructor(up : boolean = false, down: boolean = false, left: boolean = false, right: boolean = false) {
		this.up = up
		this.down = down
		this.left = left
		this.right = right
	}
}

export default abstract class Playable extends Phaser.Physics.Arcade.Sprite
{
    abstract getName(): string;

	private moved!: boolean;

    constructor(scene: Phaser.Scene, x: number, y: number, texture: string, frame?: string | number)
	{
		console.dir(Phaser)
		super(scene, x, y, texture, frame);
		this.anims.play(`${this.getName()}-idle-down`);
		this.moved = false;
	}

	public halt() {
	}

	update(obj: any) {
		if (obj) {
			var moves: PlayerMovement

			if (obj instanceof PlayerMovement)
				moves = (obj as PlayerMovement)
			else
				moves = this.parse_update_cursors(obj)

			const speed = 100

			if (moves.left)
			{
				this.anims.play(`${this.getName()}-walk-left`, true)
				this.setVelocity(-speed, 0)
				this.moved = true;
			}
			else if (moves.right)
			{
				this.anims.play(`${this.getName()}-walk-right`, true)
				this.setVelocity(speed, 0)
				this.moved = true;
			}
			else if (moves.up)
			{
				console.log("up")
				this.anims.play(`${this.getName()}-walk-up`, true)
				this.setVelocity(0, -speed)
				this.moved = true;
			}
			else if (moves.down)
			{
				this.anims.play(`${this.getName()}-walk-down`, true)
				this.setVelocity(0, speed)
				this.moved = true;
			}
			else
			{
				if (this.moved) {
					const parts = this.anims.currentAnim.key.split('-')
					parts[1] = 'idle'
					this.anims.play(parts.join('-'))
					this.setVelocity(0, 0)
					this.moved = false;
					sceneEvents.emit('player-pos-changed', this.x, this.y)
				}
			}

			if (moves.left || moves.right || moves.up || moves.down)
			{
			}
		}
	}

	parse_update_cursors(k: any)
	{
		const cursors: Phaser.Types.Input.Keyboard.CursorKeys = (k as Phaser.Types.Input.Keyboard.CursorKeys)

		return new PlayerMovement(cursors.up?.isDown, cursors.down?.isDown, cursors.left?.isDown, cursors.right?.isDown)
	}
}

export class Farmer extends Playable {
    public getName() { return "farmer"; }
}

Phaser.GameObjects.GameObjectFactory.register('alchemist', function (this: Phaser.GameObjects.GameObjectFactory, x: number, y: number, texture: string, frame?: string | number) {
	var sprite = new Alchemist(this.scene, x, y, texture, frame);

	this.displayList.add(sprite);
	this.updateList.add(sprite);

	this.scene.physics.world.enableBody(sprite, Phaser.Physics.Arcade.DYNAMIC_BODY);

	sprite.body.setSize(sprite.width * 0.5, sprite.height * 0.8);

	sprite.setBounce(BOUNCE_VAL)
	return sprite
});

Phaser.GameObjects.GameObjectFactory.register('farmer', function (this: Phaser.GameObjects.GameObjectFactory, x: number, y: number, texture: string, frame?: string | number) {
	var sprite = new Farmer(this.scene, x, y, texture, frame);

	this.displayList.add(sprite);
	this.updateList.add(sprite);

	this.scene.physics.world.enableBody(sprite, Phaser.Physics.Arcade.DYNAMIC_BODY);

	sprite.body.setSize(sprite.width * 0.5, sprite.height * 0.8);

    sprite.setBounce(BOUNCE_VAL)
	return sprite
});

Phaser.GameObjects.GameObjectFactory.register('barmaid', function (this: Phaser.GameObjects.GameObjectFactory, x: number, y: number, texture: string, frame?: string | number) {
	var sprite = new Barmaid(this.scene, x, y, texture, frame);

	this.displayList.add(sprite);
	this.updateList.add(sprite);

	this.scene.physics.world.enableBody(sprite, Phaser.Physics.Arcade.DYNAMIC_BODY);

	sprite.body.setSize(sprite.width * 0.5, sprite.height * 0.8);

    sprite.setBounce(BOUNCE_VAL)
	return sprite
});

Phaser.GameObjects.GameObjectFactory.register('bartender', function (this: Phaser.GameObjects.GameObjectFactory, x: number, y: number, texture: string, frame?: string | number) {
	var sprite = new Bartender(this.scene, x, y, texture, frame);

	this.displayList.add(sprite);
	this.updateList.add(sprite);

	this.scene.physics.world.enableBody(sprite, Phaser.Physics.Arcade.DYNAMIC_BODY);

	sprite.body.setSize(sprite.width * 0.5, sprite.height * 0.8);

    sprite.setBounce(BOUNCE_VAL)
	return sprite
});

Phaser.GameObjects.GameObjectFactory.register('blacksmith', function (this: Phaser.GameObjects.GameObjectFactory, x: number, y: number, texture: string, frame?: string | number) {
	var sprite = new Blacksmith(this.scene, x, y, texture, frame);

	this.displayList.add(sprite);
	this.updateList.add(sprite);

	this.scene.physics.world.enableBody(sprite, Phaser.Physics.Arcade.DYNAMIC_BODY);

	sprite.body.setSize(sprite.width * 0.5, sprite.height * 0.8);

    sprite.setBounce(BOUNCE_VAL)
	return sprite
});

Phaser.GameObjects.GameObjectFactory.register('fisherman', function (this: Phaser.GameObjects.GameObjectFactory, x: number, y: number, texture: string, frame?: string | number) {
	var sprite = new Fisherman(this.scene, x, y, texture, frame);

	this.displayList.add(sprite);
	this.updateList.add(sprite);

	this.scene.physics.world.enableBody(sprite, Phaser.Physics.Arcade.DYNAMIC_BODY);

	sprite.body.setSize(sprite.width * 0.5, sprite.height * 0.8);

    sprite.setBounce(BOUNCE_VAL)
	return sprite
});

Phaser.GameObjects.GameObjectFactory.register('kid01', function (this: Phaser.GameObjects.GameObjectFactory, x: number, y: number, texture: string, frame?: string | number) {
	var sprite = new Kid1(this.scene, x, y, texture, frame);

	this.displayList.add(sprite);
	this.updateList.add(sprite);

	this.scene.physics.world.enableBody(sprite, Phaser.Physics.Arcade.DYNAMIC_BODY);

	sprite.body.setSize(sprite.width * 0.5, sprite.height * 0.8);

    sprite.setBounce(BOUNCE_VAL)
	return sprite
});

Phaser.GameObjects.GameObjectFactory.register('kid02', function (this: Phaser.GameObjects.GameObjectFactory, x: number, y: number, texture: string, frame?: string | number) {
	var sprite = new Kid2(this.scene, x, y, texture, frame);

	this.displayList.add(sprite);
	this.updateList.add(sprite);

	this.scene.physics.world.enableBody(sprite, Phaser.Physics.Arcade.DYNAMIC_BODY);

	sprite.body.setSize(sprite.width * 0.5, sprite.height * 0.8);

    sprite.setBounce(BOUNCE_VAL)
	return sprite
});

Phaser.GameObjects.GameObjectFactory.register('merchant', function (this: Phaser.GameObjects.GameObjectFactory, x: number, y: number, texture: string, frame?: string | number) {
	var sprite = new Merchant(this.scene, x, y, texture, frame);

	this.displayList.add(sprite);
	this.updateList.add(sprite);

	this.scene.physics.world.enableBody(sprite, Phaser.Physics.Arcade.DYNAMIC_BODY);

	sprite.body.setSize(sprite.width * 0.5, sprite.height * 0.8);

    sprite.setBounce(BOUNCE_VAL)
	return sprite
});

Phaser.GameObjects.GameObjectFactory.register('coin', function (this: Phaser.GameObjects.GameObjectFactory, x: number, y: number, texture: string, frame?: string | number) {
	var sprite = new Phaser.Physics.Arcade.Sprite(this.scene, x, y, texture, frame);

	this.displayList.add(sprite);
	this.updateList.add(sprite);

	this.scene.physics.world.enableBody(sprite, Phaser.Physics.Arcade.DYNAMIC_BODY);
	sprite.anims.play('coin-rotate')

    sprite.setBounce(BOUNCE_VAL)
	return sprite
});

Phaser.GameObjects.GameObjectFactory.register('minter', function (this: Phaser.GameObjects.GameObjectFactory, x: number, y: number, texture: string, frame?: string | number) {
	var sprite = new Minter(this.scene, x, y, texture, frame);

	this.displayList.add(sprite);
	this.updateList.add(sprite);

	this.scene.physics.world.enableBody(sprite, Phaser.Physics.Arcade.DYNAMIC_BODY);

    sprite.setBounce(BOUNCE_VAL)
	return sprite
});
